import reducer from './reducers/index';
import routes from '../routes'
import * as onboardingTrainingTrackerActions from './actions';
import * as onboardingTrainingTrackerOperations from './operations';
import * as onboardingTrainingTrackerSelectors from './selectors';

export {
    onboardingTrainingTrackerOperations,
    onboardingTrainingTrackerSelectors,
    onboardingTrainingTrackerActions,
};

export default {
    reducer,
    routes
};
